export default {"src":"/_next/static/media/trazado-giv.8410f789.svg","height":45,"width":193,"blurWidth":0,"blurHeight":0};